export default __webpack_public_path__ + "static/image2-162301d3eb0d69bc66b86b92db74fcf0.png";